import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import copy from "copy-to-clipboard";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { BsSearch } from "react-icons/bs";
import ThemeControls from "../AllThemesControl.js";
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import TableSortLabel from '@mui/material/TableSortLabel';
import Loading from '../../images/Table/Loading.gif';
import { FormJSONCreateContext } from '../FormJSONCreateContext.js';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { visuallyHidden } from '@mui/utils';
import { FormContext } from '../Forms/FormContext.js';
import Element from "../../FormsControls/Element.js"
import * as XLSX from 'xlsx';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// import Button from '@mui/material/Button';
import Button from '../../FormsControls/Button';
import ApproveRejectComment from './ApproveRejectComment'
//testing
//import SuccessPage from '../SuccessPage'
//JSON CONTEXT

import demo from './demo.json';

//APISERVICES
import { APIGET, APIDEL, APIPATCH, APIPOST } from '../../services/APIServices.js';
//import SuccessPage from '../SuccessPage';

//Navigation
import { useNavigate, Link } from 'react-router-dom';
import { render } from '@testing-library/react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


export default function Details(obj) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const apiContextObj = obj.apiContextObj;
  const _columns = obj.viewJson[apiContextObj?.approveRejectFlow?.columns];
  const [dataSource, setDataSource] = useState([]);

  const [open, setOpen] = React.useState(false);

  const [editRowOpen, setEditRowOpen] = React.useState(false);
  const [indexPer, setIndexPer] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [searchValue, setSearchValue] = useState('');
  // const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [loading, setLoading] = useState(true);
  const [editJson, setEditJson] = useState(obj.EditJson);
  const [refresh, setRefresh] = useState(false)
  const [path, setPath] = React.useState("");
  const isDisabled = dataSource.length === 0;

  const apiPath = apiContextObj.approveRejectFlow.apiContextGet;

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const formFieldsJson = obj.createJson;
  //Setting_data for view table.===>
  let navigate = useNavigate();

  const { index, dataArr ,contextJson} = obj
  console.log(_columns)
  useEffect(() => {
    let initialRender = true;
    async function settingData() {
      const url = apiPath.apiContext + apiPath.type + dataArr[apiPath.id];
      return await APIGET(url).then(data => {
        try {
          if (data.data) {
            if (Array.isArray(data.data)) {
              const filterData = data.data.filter(obj => obj.status==="Pending")
              setDataSource(filterData);
              setFilteredData(filterData);
              if(filterData.length===0){
                obj.close()
              }
            } else if (typeof data.data === 'object') {
              const filterData= [data.data].filter(obj => obj.status==="Pending")
              setDataSource(filterData);
              setFilteredData(filterData);
              if(filterData.length===0){
                obj.close() 
              }
            } else {
              console.log("The data is neither an array nor an object.");
            }
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false);
        }
      })
    }

    if (apiPath) {
      settingData();
    }
  }, [apiPath, refresh])

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleInputChange = (e) => {
    let value = e.target.value
    // setSearchValue(e.target.value);
    document.getElementById('searchInputDataTable').value = value;
    
  }

  function searchdata() {
    const searchValue = document.getElementById('searchInputDataTable').value
    if (searchValue) {
      const filteredResult = filteredData.filter((item) => {
        return Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(searchValue.toLowerCase())
        );
      });
      console.log(filteredResult)
      if(filteredResult.length>0){
        setDataSource(filteredResult)
      }else{
        alert('No Record Found')
      }
    }
  }

  const closePopup = () => {
    setOpen(() => (!(open)));
    setRefresh(prev=>!prev)
  }

  function approvePolicy(i) {
    if(selected.length>0){
      setOpen(true)
      setPath('approve');
      // setIndexPer(i)
    }else{
      alert('Please select CheckBox')
    }
  }
  function rejectPolicy(i) {
    if(selected.length>0){
      setOpen(true)
      setPath('reject')
      // setIndexPer(i)
    }else{
      alert('Please select CheckBox')
    }
  }

  // useEffect(() => {
  //   const startIndex = page * rowsPerPage;
  //   const endIndex = startIndex + rowsPerPage;
  //   if (dataSource) {
  //     setFilteredData(stableSort(dataSource, getComparator(order, orderBy)).slice(
  //       startIndex,
  //       endIndex,
  //     ))
  //   }
  // }, [dataSource, order, orderBy, page, rowsPerPage])

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSource.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(dataSource, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, dataSource],
  );

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  //
  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          mt: 3,
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: '1 1 100%' }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            sx={{ flex: '1 1 100%' }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            <div className={classes.filtersearch}>
              <input  id="searchInputDataTable" type="text" onChange={handleInputChange} className={classes.searchInput} placeholder="Search" />
              {/* <div className={classes.searchbtn} onClick={searchdata}><BsSearch /></div> */}
              <IconButton onClick={searchdata}>
                <BsSearch />
              </IconButton>
            </div>
          </Typography>
        )}

        {numSelected > 0 ? (
          <>
          </>
        ) : (
          <>
          </>
        )}
      </Toolbar>
    );
  }
  function resetTable(data) {
    if (data.dataRecevied.statusCode === "SUCCESS" || data.dataRecevied.statusCode === "Success") {
      setRefresh(!refresh)
      setEditRowOpen()
    }
  }

  async function updateData(data, index, path) {
    //console.log(path)
    try {
      const response = await APIPATCH(apiContextObj.apiContextSave + path + data[apiContextObj.id], data, formFieldsJson, resetTable, {});
      if (response) {
        response.then((responseData) => {
        })
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  //************************* xls
  function generateXLSX(data, headers) {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers.map(header => header.dataIndex) });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    return new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  const downloadXLSX = (data, headers) => {
    const xlsBlob = generateXLSX(data, headers);
    const url = URL.createObjectURL(xlsBlob);
    const link = document.createElement('a');

    // Assuming contextHeading is a property in data or headers
    const filename = (apiContextObj.contextHeading || '').toLowerCase().replace(" ", "_") + ".xlsx";

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //*****************((((((pdf)))))) */

  function generatePDF(data, headers) {
    const table = {
      width: 100,
      headerRows: 1,
      body: [
        headers.map(header => header.title),
        ...data.map(row => headers.map(header => row[header.dataIndex] || ''))
      ]
    };
    const headerContent = [
      { text: apiContextObj.contextHeading, style: 'header' },
    ];

    const documentDefinition = {
      content: [
        {
          columns: [
            { width: '*', text: '' },
            { width: 'auto', stack: headerContent, margin: [0, 0, 0, 10] },
            { width: '*', text: '' },
          ]
        },
        { table: table }
      ],
      styles: {
        header: {
          fontSize: 12,  // Set the font size to 12px
          bold: true,
          margin: [0, 0, 0, 10]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 12,  // Set the font size to 12px
          color: '#363636'
        }
      },
      defaultStyle: {
        fontSize: 12,
      }
    };


    return pdfMake.createPdf(documentDefinition);
  }

  const downloadPDF = (data, headers) => {
    const pdfDoc = generatePDF(data, headers);
    pdfDoc.download((apiContextObj.contextHeading || '').toLowerCase().replace(" ", "_") + '.pdf');
  };

  const handleInvoiceInfo = (id) => {
    if (apiContextObj.editFlow.routeFlow.routes && id) {
      let pathname = `${apiContextObj.editFlow.routeFlow.routes}/${id}`;
      navigate(pathname);
    }
  };

  //Rendering Rows
  function RenderRow(row, index) {
    if (index < dataSource.length) {
      let arr = row;
      const postData = arr
      let keys = _columns?.map((column) => ({
        dataIndex: column.dataIndex,
        field_type: column.field_type,
      }));


      function setDataOnEdit() {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields = updatedEditJson.fields.map((field) => {
          if (field.field_id in arr) {
             
            return { ...field, field_value: arr[field.field_id] };
          }
          return field;
        });

        setEditJson(updatedEditJson);
      }



      // 
      const isSelected = (name) => selected.indexOf(name) !== -1;
      const isItemSelected = isSelected(row);

      const labelId = `enhanced-table-checkbox-${index}`;


      function verifyStatus(originalData, index) {
        const contaxt = '/approve/'
        const newData = {
          ...originalData
        };
        updateData(newData, index, contaxt)
      }

      function tablecellValue(key) {
        if (typeof key === 'string') {
          return String(arr[key] || '');
        } else if (Array.isArray(key)) {
          let value = "";
          for (const item of key) {
            if (item.column) {
              value += String(arr[item.column] || '');
            } else if (item.condition) {
              value += eval(item.condition);
            } else if (item.string) {
              value += item.string;
            }
          }
          return value;
        } else {
          // It is neither a string nor an array.
          return null; // Set the return value to null explicitly.
        }
      }

      const handleChange = (id, event, value) => {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields = updatedEditJson.fields.map((field) => {
          if (id === field.field_id) {
            //console.log(value)
            postData[field.field_id] = value;
            return { ...field, field_value: value };
          }
          return field;
        });

        setEditJson(updatedEditJson);
      };
      // //console.log(keys.map((key) => arr[key.dataIndex]))
      if(row.status==="Pending"){
        return (
          <React.Fragment>
            <TableRow
              role="checkbox"
              aria-checked={isItemSelected}
              tabIndex={-1}
              selected={isItemSelected}
              sx={{ cursor: 'pointer' }}
            >
              <StyledTableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  checked={isItemSelected}
                  onClick={(event) => handleClick(event, row)}
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </StyledTableCell>
              {keys?.map((key) => (
                (String(arr[key.dataIndex]) === "null" || String(arr[key.dataIndex]) === "") && key.dataIndex === "varifiedbyusername" ?
                  <StyledTableCell onClick={() => verifyStatus(postData, index)} value={String(arr[key.dataIndex])}>
                    <span style={{ color: '#0055d4' }}>Verify</span>
                  </StyledTableCell> :
                  <StyledTableCell value={String(arr[key.dataIndex])}>
                    {
                      key.field_type && editRowOpen === index ?
                        <FormContext.Provider value={{ handleChange }}>
                          {editJson.fields && editJson.fields.map((field, i) => {
                            if (field.field_id === key.dataIndex) {
                              return (<Element key={i} field={field} />)
                            }
                          })
                          }
                        </FormContext.Provider> :
                        <div style={{ display: 'flex' }}>
                          <span></span>
                          <div>{tablecellValue(key.dataIndex) === null ? "" : tablecellValue(key.dataIndex)}</div>
                        </div>
                    }
                  </StyledTableCell>
              ))}
  
              {/* <StyledTableCell className='actionTd'>
                <button className={classes.rejectBtn} onClick={() => { rejectPolicy(index) }}>Reject</button>
                <button className={classes.approveBtn} onClick={() => { approvePolicy(index) }}>Approve</button>
              </StyledTableCell> */}
            </TableRow>
          </React.Fragment>
        );
      }else{
        return null
      }
    }
  }

  const handleClose = () => {
    setErrorOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = dataSource.map((n) => n);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <React.Fragment>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={errorOpen} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog className={classes.poup}
        // fullScreen
        open={open}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
      >
        <ApproveRejectComment contextJson={contextJson} setRefresh={setRefresh} setOpen={setOpen} setErrorMsg={setErrorMsg} setErrorOpen={setErrorOpen} index={indexPer} path={path} dataArr={dataArr}  selected={selected} setSelected={setSelected}  dataRow={dataSource[indexPer]} close={() => (closePopup())} apiContextObj={apiContextObj}/>
      </Dialog>

      <div className={classes.detailsPopup}>
        <div className={classes.headerSticky}>
          <CloseIcon onClick={obj.close} />
          <h4>{apiContextObj.approveRejectFlow.contextHeading}</h4>
        </div>
        <div>
          {loading ?
            <div className={classes.loader}>
              <img src={Loading} alt="Loading..." />
            </div> :
            <>
              <EnhancedTableToolbar numSelected={selected.length} />
              <TableContainer className={classes.table}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          indeterminate={selected.length > 0 && selected.length < dataSource.length}
                          checked={dataSource.length > 0 && selected.length === dataSource.length}
                          onChange={handleSelectAllClick}
                          inputProps={{
                            'aria-label': 'select all desserts',
                          }}
                        />
                      </StyledTableCell>
                      {_columns?.map((column, i) => (<StyledTableCell
                        // key={i}
                        // align={column.numeric ? 'right' : 'left'}
                        // padding={column.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === column.dataIndex ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === column.dataIndex}
                          direction={orderBy === column.dataIndex ? order : 'asc'}
                          onClick={createSortHandler(column.dataIndex)}
                        >
                          {column.title}
                          {orderBy === column.dataIndex ? (
                            <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      </StyledTableCell>
                      ))}
                      {/* <StyledTableCell>ACTION</StyledTableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {visibleRows.length===0 ?(<td colSpan={_columns.length+1}>No Data</td>):
                    visibleRows.map((arr, index) => (RenderRow(arr, index)))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className={classes.pagination}>
                <TablePagination
                  component="div"
                  labelRowsPerPage='Show row per page'
                  count={dataSource.length}
                  page={page}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 50, 100, 500]}
                />
              </div>
              {visibleRows.length>0&&<div className={classes.rejApr}> 
                <Button ButtonName="Reject" onClick={rejectPolicy}/>
                <Button ButtonName="Approve" onClick={approvePolicy} />
              </div>}
            </>
          }
        </div>
      </div>

    </React.Fragment>
  );
}




